<template>
  <!-- 忘記密碼頁面-->
  <app-logo-page-container>
    <v-flex xs10 sm6 md3>
      <v-form
        class="mt-2"
        ref="form"
        v-model="valid"
        @submit.prevent>

        <p class="mt-2 mb-4">我們將會寄送重設密碼的確認信至您填寫的信箱</p>

        <v-text-field
          v-model="email"
          prepend-icon="email"
          label="電子郵件"
          color="black"
          :rules="emailRules"
          @keyup.enter="submit"
          validate-on-blur />

          <v-btn
            class="mt-4 white--text"
            color="pink"
            :loading="loading"
            @click="submit"
            block>
            發送至信箱
          </v-btn>

          <v-alert
            class="mt-4"
            v-if="errMsg"
            transition="slide-y-transition"
            :value="true"
            type="error">
            {{errMsg}}
          </v-alert>

          <v-alert
            v-if="hasSent"
            class="mt-4"
            transition="slide-y-transition"
            :value="true"
            type="info">
            我們已將重至密碼的信件寄送到您的電子郵件
          </v-alert>

          <v-btn
            class="mt-4"
            :color="hasSent ? 'primary' : ''"
            @click="$router.push({name: 'Signin'})"
            block
            flat>
            <v-icon class="mr-2">arrow_back</v-icon>
            返回登入頁
          </v-btn>
      </v-form>
    </v-flex>
  </app-logo-page-container>
</template>

<script>
import {mapActions} from 'vuex';
import {email} from '@/validate-rules';

export default {
  data() {
    return {
      valid: true,
      hasSent: false,
      loading: false,
      errMsg: null,
      email: '',
      emailRules: email.rules()
    };
  },

  methods: {
    ...mapActions(['resetPassword']),

    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.errMsg = null;
      this.loading = true;
      try {
        await this.resetPassword(this.email);
        this.hasSent = true;
        setTimeout(() => this.$router.push({name: 'Signin'}), 3000);
      } catch (e) {
        this.errMsg = e.message;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>

</style>
